

import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { Smartphone, Lock, ShieldCheck, ArrowRight, RefreshCw } from "lucide-react";
import { apiRequest } from "../../apiService/allApi";
import "react-toastify/dist/ReactToastify.css";
// import "./Login.css";

export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { referralcode } = useParams();

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [isValid, setIsValid] = useState(false);
  const [seconds, setSeconds] = useState(60);

  const referral = referralcode || location.pathname.split("/")[2] || "";

  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      clearInterval(timerInterval);
      setIsValid(false);
    }
    return () => clearInterval(timerInterval);
  }, [isValid, seconds]);

  const handleClick = async (e) => {
    e?.preventDefault();
    if (!Phone || Phone.length !== 10) {
      return toast.error("Please enter a valid 10-digit mobile number.", {
        position: "top-center",
        theme: "dark",
      });
    }

    setIsloading1(true);
    const respone = await apiRequest("login", "POST", { Phone, referral });
    setIsloading1(false);

    if (respone?.data?.status === 200) {
      setOtp(true);
      setIsValid(true);
      setSeconds(60);
      setSecretCode(respone?.data?.secret);
      
      toast.success("OTP sent successfully!", { position: "top-center", theme: "dark" });

      if (respone?.data?.myToken) {
        toast.info(`Demo OTP: ${respone?.data?.myToken}`, {
          position: "top-center",
          autoClose: 10000,
          theme: "dark",
        });
      }
    } else {
      toast.error(respone?.data?.msg || "Login failed. Please try again.", {
        position: "top-center",
        theme: "dark",
      });
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    setIsloading1(true);
    try {
      const response = await apiRequest("login/finish", "POST", {
        Phone,
        twofactor_code,
        referral,
        secretCode,
      });
      setIsloading1(false);

      if (response?.data?.status === 200) {
        toast.success("Verification successful! Redirecting...", {
          position: "top-center",
          theme: "dark",
        });
        localStorage.setItem("token", response?.data?.token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        toast.error(response?.data?.msg || "Invalid OTP. Please try again.", {
          position: "top-center",
          theme: "dark",
        });
      }
    } catch (error) {
      setIsloading1(false);
      toast.error("Error verifying OTP. Please try again.", {
        position: "top-center",
        theme: "dark",
      });
    }
  };

  return (
    <div className="classic-page-wrapper">
      <ToastContainer limit={3} />
      
      {/* Background ambient lighting elements */}
      <div className="ambient-glow glow-1"></div>
      <div className="ambient-glow glow-2"></div>

      <div className="classic-card">
        {/* Top Branding Section */}
        <div className="classic-header">
          <div className="logo-badge">
            <img src="/baji.png" alt="BAJIGERLUDO" className="brand-logo" />
          </div>
          <h2 className="brand-title">Welcome Back</h2>
          <p className="brand-subtitle">
            {otp ? "Enter the verification code sent to your phone" : "Enter your mobile number to get started"}
          </p>
        </div>

        {/* Input Form */}
        <form onSubmit={otp ? varifyOtp : handleClick} className="classic-form">
          <div className="input-field-group">
            <label className="field-label">Mobile Number</label>
            <div className={`input-wrapper ${otp ? "readonly" : ""}`}>
              <span className="country-tag">+91</span>
              <input
                type="tel"
                className="classic-input"
                placeholder="98765 43210"
                value={Phone}
                disabled={otp}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                required
              />
              <Smartphone className="input-icon" size={18} />
            </div>
          </div>

          {otp && (
            <div className="input-field-group animate-slide-up">
              <div className="label-row">
                <label className="field-label">Verification OTP</label>
                <span className="security-badge">
                  <ShieldCheck size={14} /> Encrypted
                </span>
              </div>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="classic-input otp-input"
                  placeholder="• • • • • •"
                  maxLength={6}
                  onChange={(e) => settwofactor_code(e.target.value)}
                  required
                  autoFocus
                />
                <Lock className="input-icon" size={18} />
              </div>

              {/* Timer & Resend Option */}
              <div className="timer-container">
                {seconds > 0 ? (
                  <span className="timer-text">
                    Resend available in <strong>{seconds}s</strong>
                  </span>
                ) : (
                  <button
                    type="button"
                    className="resend-btn"
                    onClick={handleClick}
                    disabled={isLoading1}
                  >
                    <RefreshCw size={14} /> Resend OTP
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Action Button */}
          <button type="submit" className="classic-submit-btn" disabled={isLoading1}>
            {isLoading1 ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <>
                <span>{otp ? "Verify & Continue" : "Send OTP"}</span>
                <ArrowRight size={18} />
              </>
            )}
          </button>
        </form>

        {/* Footer info */}
        <div className="classic-footer">
          <p>Protected by end-to-end security protocol</p>
        </div>
      </div>
    </div>
  );
}